import { render, staticRenderFns } from "./DocumentenUpload.vue?vue&type=template&id=147c7286&scoped=true"
import script from "./DocumentenUpload.vue?vue&type=script&lang=js"
export * from "./DocumentenUpload.vue?vue&type=script&lang=js"
import style0 from "./DocumentenUpload.vue?vue&type=style&index=0&id=147c7286&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147c7286",
  null
  
)

export default component.exports